<!--  -->
<template>
  <div>
    <v-btn
      color="primary"
      depressed
      small
      height="30"
      style="padding: 0 8px"
      min-width="30"
      class="mr-2 mb-2"
      @click="openDialog()"
    >
      <v-icon size="18">mdi-plus</v-icon>新增配置
    </v-btn>
    <div class="overflow-auto" style="width: 70%">
      <v-data-table
        :headers="tableHeader"
        :items="tableItems"
        :items-per-page="params.pageSize"
        class="max-width header-grey"
        hide-default-footer
        item-key="id"
        no-data-text="暂无查询数据"
        :loading="loading"
        disable-sort
      >
        <template v-slot:item.action="{ item }">
          <div class="flex-y-center">
            <v-icon
              color="primary"
              size="12"
              title="删除"
              class="mr-3"
              @click="openDialog(item)"
            >修改</v-icon>
            <v-icon
              color="error"
              size="12"
              title="删除"
              class="mr-3"
              @click="handleDelete(item)"
            >删除</v-icon>
          </div>
        </template>
      </v-data-table>
    </div>
    <div class="flex-justify-start">
      <pagination
        v-model="params.pageNo"
        :size="params.pageSize"
        :total="total"
        @input="getList()"
        @changePageSize="
          (e) => {
            params.pageSize = e;
            getList();
          }
        "
      />
    </div>
    <re-dialog
      :value.sync="dialogVisible"
      :title="dialogParams.id ? '修改配置' : '新增配置'"
      :width="500"
      @ok="handleOk"
    >
      <div class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>配置名称：
        </div>
        <form-item
          v-model="dialogParams.configName"
          class="mr-0"
          placeholder="配置名称"
          required
          type="text"
        />
      </div>
      <div class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>适用组织角色：
        </div>
        <form-item
          v-model="dialogParams.applicableRoles"
          class="mr-0"
          placeholder="适用组织角色："
          required
          type="select"
          :options="roleOptions"
          multiple
        />
      </div>
      <div class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>水印内容：
        </div>
        <form-item
          v-model="dialogParams.watermarkContent"
          class="mr-0"
          placeholder="例如:绝密文件|${username}${timestamp}正在浏览"
          required
          type="textarea"
        />
      </div>
      <div class="dialog-form-item">
        <div class="dialog-form-item__label" />
        <div style="color: orange">
          支持变量：${username} (用户名)、${timestamp} (时间戳)
        </div>
      </div>
    </re-dialog>
  </div>
</template>

<script>
export default {
  name: 'WaterMarkSetting',
  data() {
    return {
      tableHeader: [
        {
          text: '配置名称',
          value: 'configName',
        },
        {
          text: '适用组织角色',
          value: 'applicableRolesNames',
        },
        {
          text: '最后修改时间',
          value: 'updateTime',
        },
        {
          text: '操作',
          value: 'action',
        },
      ],
      tableItems: [],
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      loading: false,
      dialogVisible: false,
      dialogParams: {
        id: '',
        applicableRoles: [],
        watermarkContent: '',
        configName: '',
      },
      roleOptions: [],
    };
  },
  mounted() {
    this.initLoad();
  },
  methods: {
    getRoleOptions() {
      this.$http
        .get(this.$api.roleList, {
          data: { pageNo: 1, pageSize: 999, roleCategory: '0' },
        })
        .then((res) => {
          console.log(res);
          if (res.result.records && res.result.records.length) {
            res.result.records.forEach((item) => {
              item.text = item.roleName;
              item.value = item.id;
            });
          }
          this.roleOptions = [
            { text: '外部', value: '0' },
            ...(res.result.records || []),
          ];
        });
    },
    initLoad() {
      this.params.pageNo = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$http
        .get(this.$api.watermarkSettingList, {
          data: this.params,
        })
        .then((res) => {
          this.tableItems = res.result.records || [];
          this.total = res.result.total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDialog(item = null) {
      this.getRoleOptions();
      if (item) {
        Object.keys(this.dialogParams).forEach((key) => {
          this.dialogParams[key] = item[key];
          if (key === 'applicableRoles') {
            this.dialogParams[key] = item[key].split(',');
          }
        });
      } else {
        this.dialogParams = {
          id: '',
          applicableRoles: [],
          watermarkContent: '',
          configName: '',
        };
      }
      this.dialogVisible = true;
    },
    handleDelete(item) {
      this.$confirm({ text: '确认删除吗？' }).then((vm) => {
        console.log(vm);
        vm.loading = true;
        this.$http
          .delete(this.$api.watermarkSettingDelete, {
            data: { id: item.id },
          })
          .then((res) => {
            this.$message.success('删除成功');
            this.getList();
            vm.show = false;
            vm.loading = false;
          });
      });
    },
    handleOk() {
      const api = this.dialogParams.id
        ? this.$api.watermarkSettingUpdate
        : this.$api.watermarkSettingSave;
      const method = this.dialogParams.id ? 'put' : 'post';
      this.$http[method](api, {
        data: {
          ...this.dialogParams,
          applicableRoles: this.dialogParams.applicableRoles.join(','),
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('操作成功');
          this.dialogVisible = false;
          if (this.dialogParams.id) {
            this.initLoad();
          } else {
            this.getList();
          }
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &__label {
    width: 120px;
    flex-shrink: 0;
    text-align: right;
  }
}
</style>
